import React, { useEffect } from 'react';
import PurchaseBillsTable from '../../../component/InputTable/PurchaseBillsTable';

const BillTable = ({
	pbId,
	tableData,
	setTableData,
	disabled,
	paramId,
	tableError,
	isResetTable,
	errorCells,
	setErrorCells,
	setIsTableErrorShow,
}) => {
	const handleTableChange = (newData) => {
		setTableData(newData);
	};

	const columns = [
		{ name: 'product_id', label: 'Product Name', type: 'product_name' },
		{ name: 'batch_no', label: 'Batch No', type: 'batch_no' },
		{ name: 'quantity', label: 'Qty', type: 'text' },
		{ name: 'free_quantity', label: 'Free', type: 'text' },
		{ name: 'purchase_rate', label: 'Rate', type: 'text' },
		{ name: 'discount', label: 'Disc %', type: 'text' },
		{ name: 'mfg_date', label: 'MFG', type: 'date' },
		{ name: 'exp_date', label: 'EXP', type: 'date' },
		{ name: 'mrp', label: 'MRP', type: 'text' },
		{ name: 'amount', label: 'Amount', type: 'text' },
	];

	const initialRows = [
		{
			product_id: '',
			batch_no: '',
			quantity: '0',
			free_quantity: '0',
			purchase_rate: '0.00',
			discount: '0.00',
			mfg_date: '',
			exp_date: '',
			mrp: '0.00',
			amount: '0.00',
			product_batch_id: '',
			product_tax1: 0,
			product_tax2: 0,
		},
	];

	return (
		<div
			className="max-w-1297"
			style={{ padding: '0rem 2rem' }}
		>
			{tableData && (
				<PurchaseBillsTable
					pbId={pbId}
					initialRows={initialRows}
					columns={columns}
					onChange={handleTableChange}
					value={tableData}
					isResetTable={isResetTable}
					disabled={disabled}
					errorCells={errorCells}
					setErrorCells={setErrorCells}
					newRowgenerate={'Quantity Adjusted'}
					returnInputvalue={false}
					paramId={paramId}
					tableError={tableError}
					setIsTableErrorShow={setIsTableErrorShow}
				/>
			)}
		</div>
	);
};

export default BillTable;
